import React                from "react";
import PropTypes            from "prop-types";
import { connect }          from "react-redux";
import Status               from "dashboard/dist/Core/Status";
import Utils                from "dashboard/dist/Utils/Utils";

// Components
import MediaField           from "Components/Utils/Media/MediaField";
import EditDialog           from "dashboard/dist/Components/EditDialog";
import Columns              from "dashboard/dist/Components/Columns";
import InputField           from "dashboard/dist/Components/InputField";

// Actions
import {
    fetchMaterial, fetchMaterialCreate, editMaterial,
} from "Actions/Admin/Coach/MaterialActions";



/**
 * The Coach Material Edit Dialog
 */
class MaterialEdit extends React.Component {
    // The Initial Data
    initialData = {
        materialID   : 0,
        name         : "",
        type         : 0,
        file         : "",
        position     : 0,
        status       : Status.getID("ACTIVE"),
        observations : "",
    }

    // The Current State
    state = {
        loading : false,
        data    : { ...this.initialData },
        errors  : {},
    }



    /**
     * Get the Data when the Element ID changes
     * @param {Object} prevProps
     * @returns {Void}
     */
    componentDidUpdate(prevProps) {
        const { open, edition, elemID, elem, position, fetchMaterial, fetchMaterialCreate } = this.props;
        let loading = false;
        let data    = null;

        // Dialog Opens
        if (open && !prevProps.open) {
            data = { ...this.initialData };
            // Load new data
            if (elemID) {
                fetchMaterial(elemID);
                loading = true;
            // Load edit data
            } else {
                fetchMaterialCreate();
                loading = true;
            }

        // Data Updated
        } else if (prevProps.edition !== edition) {
            if (elemID) {
                data = Utils.extend(this.initialData, elem);
            } else {
                data = { ...this.initialData, position };
            }
        }

        // Set the State
        if (data) {
            this.setState({ data, loading, errors : {} });
        }
    }

    /**
     * Handles the Input Change
     * @param {String} name
     * @param {*}      value
     * @returns {Void}
     */
    handleChange = (name, value) => {
        this.setState({
            data   : { ...this.state.data,   [name] : value },
            errors : { ...this.state.errors, [name] : ""    },
        });
    }

    /**
     * Handles the Submit
     * @returns {Promise}
     */
    handleSubmit = async () => {
        const { data, loading } = this.state;
        if (!loading) {
            this.setState({ loading : true, errors : {} });
            try {
                await this.props.editMaterial(data);
                this.setState({ loading : false });
                this.props.onSubmit();
            } catch (errors) {
                this.setState({ loading : false, errors });
            }
        }
    }



    /**
     * Does the Render
     * @returns {Object}
     */
    render() {
        const { elemID, open, onClose } = this.props;
        const { data, loading, errors } = this.state;

        return <EditDialog
            open={open}
            icon="material"
            title={!!elemID ? "COACH_MATERIALS_EDIT_TITLE" : "COACH_MATERIALS_CREATE_TITLE"}
            error={errors.form}
            onSubmit={this.handleSubmit}
            onClose={onClose}
            isLoading={loading}
        >
            <InputField
                name="name"
                label="MATERIALS_ITS_NAME"
                value={data.name}
                error={errors.name}
                onChange={this.handleChange}
                isRequired
            />
            <InputField
                type="select"
                name="type"
                label="MATERIALS_TYPE"
                value={data.type}
                error={errors.type}
                onChange={this.handleChange}
                options="MATERIALS_TYPES"
                withNone
                isRequired
            />
            <MediaField
                isHidden={Number(data.type) !== 1}
                name="file"
                label="MATERIALS_FILE"
                mediaPath="materiales"
                value={data.file}
                error={errors.file}
                onChange={this.handleChange}
                isRequired
            />
            <InputField
                isHidden={Number(data.type) !== 2}
                name="file"
                label="MATERIALS_VIDEO"
                value={data.file}
                error={errors.file}
                onChange={this.handleChange}
                isRequired
            />
            <InputField
                isHidden={Number(data.type) !== 3}
                name="file"
                label="MATERIALS_LINK"
                value={data.file}
                error={errors.file}
                onChange={this.handleChange}
                isRequired
            />
            <Columns>
                <InputField
                    type="number"
                    name="position"
                    label="GENERAL_POSITION"
                    value={data.position}
                    error={errors.position}
                    onChange={this.handleChange}
                    shrinkLabel
                />
                <InputField
                    type="select"
                    name="status"
                    label="GENERAL_STATUS"
                    value={data.status}
                    error={errors.status}
                    onChange={this.handleChange}
                    options={Status.getSelect()}
                    withNone
                    isRequired
                    shrinkLabel
                />
            </Columns>
            <InputField
                type="textarea"
                name="observations"
                label="GENERAL_OBSERVATIONS"
                value={data.observations}
                onChange={this.handleChange}
            />
        </EditDialog>;
    }



    /**
     * The Property Types
     * @typedef {Object} propTypes
     */
    static propTypes = {
        fetchMaterial       : PropTypes.func.isRequired,
        fetchMaterialCreate : PropTypes.func.isRequired,
        editMaterial        : PropTypes.func.isRequired,
        open                : PropTypes.bool.isRequired,
        onClose             : PropTypes.func.isRequired,
        onSubmit            : PropTypes.func.isRequired,
        edition             : PropTypes.number.isRequired,
        position            : PropTypes.number.isRequired,
        elem                : PropTypes.object.isRequired,
        elemID              : PropTypes.number,
    }

    /**
     * Maps the State to the Props
     * @param {Object} state
     * @returns {Object}
     */
    static mapStateToProps(state) {
        return {
            edition  : state.coachMaterial.edition,
            position : state.coachMaterial.position,
            elem     : state.coachMaterial.elem,
        };
    }
}

export default connect(MaterialEdit.mapStateToProps, {
    fetchMaterial, fetchMaterialCreate, editMaterial,
})(MaterialEdit);
